'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const CircledEmptyCrossIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="CircledEmptyCrossIcon">
      <svg width="61" height="60" viewBox="0 0 61 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_2350_12216)">
          <path
            d="M0.5 30C0.5 37.9565 3.66071 45.5871 9.2868 51.2132C14.9129 56.8393 22.5435 60 30.5 60C38.4565 60 46.0871 56.8393 51.7132 51.2132C57.3393 45.5871 60.5 37.9565 60.5 30C60.5 22.0435 57.3393 14.4129 51.7132 8.7868C46.0871 3.16071 38.4565 0 30.5 0C22.5435 0 14.9129 3.16071 9.2868 8.7868C3.66071 14.4129 0.5 22.0435 0.5 30Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.0584 17.0128C20.8032 15.7576 18.768 15.7576 17.5127 17.0128C16.2575 18.2681 16.2575 20.3033 17.5127 21.5585L25.9542 30L17.5127 38.4414C16.2575 39.6967 16.2575 41.7319 17.5127 42.987C18.768 44.2423 20.8032 44.2423 22.0584 42.987L30.4998 34.5457L38.9413 42.987C40.1965 44.2423 42.2317 44.2423 43.4869 42.987C44.7421 41.7319 44.7421 39.6967 43.4869 38.4414L35.0455 30L43.4869 21.5585C44.7421 20.3033 44.7421 18.2681 43.4869 17.0128C42.2317 15.7576 40.1965 15.7576 38.9413 17.0128L30.4998 25.4543L22.0584 17.0128Z"
            fill="#5073C3"
          />
        </g>
        <defs>
          <clipPath id="clip0_2350_12216">
            <rect width="60" height="60" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

CircledEmptyCrossIcon.propTypes = {
  sx: PropTypes.object
}
